import React from "react"
import SupportPanelItem from "./support-panel-item"
import * as SelectionFactoryHelper from "../helpers/SelectionFactoryHelper"
import PropTypes from "prop-types"
import ReactHtmlParser from "react-html-parser"

export default function SupportPanel({ fontColor, header, headerLabel, listItems, desktopImage, desktopImageAltText, richTextContent }) {
  const selectedFontColor = SelectionFactoryHelper.getFromSelectionFactory(fontColor)

  const htmlPanelItems =
    listItems && listItems.length > 0
      ? listItems.map((card, index) => {
          return (
            <SupportPanelItem
              key={(card.listItemUrl || header) + "-" + index}
              isMapsLink={card.isMapsLink}
              listBulletIcon={SelectionFactoryHelper.getFromSelectionFactory(card.listBulletIcon)}
              listItemText={ReactHtmlParser(card.listItemText)}
              listItemUrl={card.listItemUrl}
              listLinkTitle={card.listLinkTitle}
              latitude={card.latitude}
              longitude={card.longitude}
              fontColor={selectedFontColor}
              linkTarget={SelectionFactoryHelper.getFromSelectionFactory(card.linkTarget)}
              isUrl={!!card.listItemUrl}
            />
          )
        })
      : undefined

  return (
    <section className={`support-panel-section ${richTextContent ? "w--narrow" : "w--wider"}`}>
      <div className={`support-panel-content-section ${richTextContent ? "text-version" : "image-version"}`}>
        <p className="support-panel-label">{headerLabel}</p>
        <div className={`support-panel-container ${desktopImage ? "" : "full-width-panel"} ${selectedFontColor}`}>
          <h2 className="support-panel-heading">{ReactHtmlParser(header)}</h2>
          <ul className="support-panel-items">{htmlPanelItems}</ul>
        </div>
      </div>
      <div className={`outer-image-container ${richTextContent ? "no-image" : ""}`}>
        {!richTextContent && desktopImage ? (
          <div className="image-container">
            <img alt={desktopImageAltText} src={desktopImage}></img>
          </div>
        ) : richTextContent ? (
          <div className="wrapping-text-container rich-text">{ReactHtmlParser(richTextContent)}</div>
        ) : undefined}
      </div>
    </section>
  )
}

SupportPanel.propTypes = {
  backgroundColor: PropTypes.arrayOf(PropTypes.object),
  fontColor: PropTypes.arrayOf(PropTypes.object),
  header: PropTypes.string,
  listItems: PropTypes.arrayOf(PropTypes.object),
  desktopImage: PropTypes.string,
  richTextContent: PropTypes.string,
  desktopImageAltText: PropTypes.string,
}

SupportPanel.defaultProps = {
  backgroundColor: [{}],
  fontColor: [{}],
  header: "",
  listItems: [{}],
  desktopImage: "",
  richTextContent: "",
  desktopImageAltText: "",
}
